import type { CoreApiClient } from "../client";
import type { Alarm, CreateAlarmsRequestBody, UpdateAlarmRequestBody } from "../types/alarm.type";

export const createAlarmMutations = (api: CoreApiClient) => {
  const { request } = api;

  /** Create one or many alarms in a building (the endpoint takes an array; pass `[dto]` for a single create). */
  const create = async (buildingId: string, body: CreateAlarmsRequestBody): Promise<Alarm[]> => {
    const { data } = await request("post", "/buildings/{buildingId}/alarms", {
      params: { path: { buildingId } },
      body,
    });
    return data;
  };

  const update = async (alarmId: string, body: UpdateAlarmRequestBody): Promise<Alarm> => {
    const { data } = await request("put", "/alarms/{alarmId}", {
      params: { path: { alarmId } },
      body,
    });
    return data;
  };

  const deleteAlarm = async (alarmId: string): Promise<void> => {
    await request("delete", "/alarms/{alarmId}", {
      params: { path: { alarmId } },
    });
  };

  return {
    create,
    update,
    delete: deleteAlarm,
  };
};
